enum DimensionTypeEnum {
  Info,
  Check,
}

export default DimensionTypeEnum;
